module.exports = __webpack_public_path__ + "img/privacy-prohibit-bind.c099d903.png";